// import { DateTime } from 'luxon'
import { format } from 'date-fns';
var Wrapper;

(function (Wrapper) {
  Wrapper["Dialog"] = "dialog";
  Wrapper["Popper"] = "popper";
})(Wrapper || (Wrapper = {})); // Function for dissable sunday on calendar


export var disableSunday = function disableSunday(date) {
  if (!date) {
    return false;
  }

  return format(new Date(date), 'EEEE') === 'Sunday';
};